var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkPixel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_14609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8501 4.57001H31.3301V28.95H32.8501V4.57001Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.33 28.95H29.8V30.48H31.33V28.95Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.33 3.04999H29.8V4.56999H31.33V3.04999Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8001 30.48H3.90015V32H29.8001V30.48Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7601 24.38H6.95007V25.91H26.7601V24.38Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7601 18.29H6.95007V19.81H26.7601V18.29Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7601 12.19H19.1401V13.71H26.7601V12.19Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7601 7.62H19.1401V9.14H26.7601V7.62Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47012 3.05V13.71H9.99012V12.19H11.5201V10.67H13.0401V12.19H14.5601V13.71H16.0901V3.05H29.8001V1.52H14.5601V0H5.42012V1.52H2.37012V3.05H8.47012ZM11.5201 1.52H13.0401V3.05H14.5601V6.1H13.0401V3.05H11.5201V1.52Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90012 28.95H2.37012V30.48H3.90012V28.95Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3701 3.04999H0.850098V28.95H2.3701V3.04999Z",
    fill: "#000001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_14609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.850098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkPixel);
export default __webpack_public_path__ + "static/media/bookmark-Pixel.2057a5723036f503fc2c7848fa5c5e45.svg";
export { ForwardRef as ReactComponent };